var map = {
	"./Brot.svg": 9291,
	"./Desserts.svg": 8313,
	"./Eis.svg": 994,
	"./Grillen.svg": 1353,
	"./Kekse und Stückgebäck.svg": 3715,
	"./Nudeln.svg": 6495,
	"./Teig.svg": 8127,
	"./Timer.svg": 3360,
	"./Torten.svg": 2357,
	"./default.svg": 990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5373;